import $ from 'jquery';
import Cookies from 'js-cookie';
import _ from 'lodash';

export default function payments() {
    //Work out price to show at foot of sign up page
    let classname = document.getElementsByClassName("tally-amount")
    let invoices = [];
    let totalAmount = 0

    Array.from(classname, c => c.addEventListener("change", function (e) {
        e.preventDefault();

        if (e.currentTarget.checked) {
            invoices.push({
                invoiceNo: e.currentTarget.getAttribute('data-invoice-number'),
                amount: e.currentTarget.getAttribute('data-amount-remaining')
            });

            totalAmount = totalAmount + Number(parseFloat(e.currentTarget.getAttribute('data-amount-remaining')).toFixed(2))
        } else {
            totalAmount = totalAmount - Number(parseFloat(e.currentTarget.getAttribute('data-amount-remaining')).toFixed(2))

            invoices = _.remove(invoices, function(i) {
                return (i.invoiceNo !== e.currentTarget.getAttribute('data-invoice-number'));
            });
        }

        //Stick the formatted sum into the container;
        document.querySelector('.total-invoices').innerHTML = invoices.length + ' invoices';
        document.querySelector('.amount-payable').innerHTML = '&pound;' + (totalAmount).toFixed(2);

        let form = document.querySelector('.totals-form');

        form.querySelector('[name="invoices"]').value = JSON.stringify(invoices);
        form.querySelector('[name="total"]').value = Number((totalAmount).toFixed(2)).toLocaleString();
    }));

    if (document.getElementById('payment-form')) {
        var stripe = Stripe("pk_live_51GfSkkKRGPISZoIkqsJeod35ZOl2eIOnc120vFQjrW7WG6dtAbjVlRN3Oh8FG56d4LgF3Mxkd7jIqy3FSRjCDh7t00CP6EyjkU");
        //var stripe = Stripe("pk_test_HlMizscoQTkTNn618SVjrejQ00h7qkz0D4");

        // Disable the button until we have Stripe set up on the page
        document.querySelector("button").disabled = true;

        var elements = stripe.elements();
        var card = elements.create("card");

        // Stripe injects an iframe into the DOM
        card.mount("#card-element");
        card.on("change", function (event) {
            // Disable the Pay button if there are no card details in the Element
            document.querySelector("button").disabled = event.empty;
            document.querySelector("#card-error").textContent = event.error ? event.error.message : "";
        });

        var form = document.getElementById("payment-form");

        form.addEventListener("submit", function(event) {
            event.preventDefault();
            // Complete payment when the submit button is clicked
            payWithCard(stripe, card, window.intent);
        });

    }
}

// Calls stripe.confirmCardPayment
// If the card requires authentication Stripe shows a pop-up modal to
// prompt the user to enter authentication details without leaving your page.
var payWithCard = function(stripe, card, clientSecret) {
    loading(true);
    stripe
      .confirmCardPayment(clientSecret, {
        receipt_email: document.getElementById('stripe_email').value,
        payment_method: {
          card: card
        }
      })
      .then(function(result) {
        if (result.error) {
          // Show error to your customer
          showError(result.error.message);
        } else {
          // The payment succeeded!
          orderComplete(result.paymentIntent.id);
        }
      });
  };


/* ------- UI helpers ------- */

// Shows a success message when the payment is complete
var orderComplete = function(paymentIntentId) {
    loading(false);
    document.getElementById("payment-form").classList.add("hidden");
    document.querySelector(".success-box").classList.remove("hidden");
    document.querySelector("button").disabled = true;
};

// Show the customer the error from Stripe if their card fails to charge
var showError = function(errorMsgText) {
    loading(false);
    var errorMsg = document.querySelector("#card-error");
    errorMsg.classList.remove('hidden');
    errorMsg.innerHTML = '<p>' + errorMsgText + '</p>';
    setTimeout(function() {
      errorMsg.innerHTML = "";
      errorMsg.classList.add('hidden');
    }, 10000);
};

// Show a spinner on payment submission
var loading = function(isLoading) {
    if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector("button").disabled = true;
        document.querySelector("#spinner").classList.remove("hidden");
        document.querySelector("#button-text").classList.add("hidden");
    } else {
        document.querySelector("button").disabled = false;
        document.querySelector("#spinner").classList.add("hidden");
        document.querySelector("#button-text").classList.remove("hidden");
    }
};
